import script from "./LimitTagList.vue?vue&type=script&setup=true&lang=js"
export * from "./LimitTagList.vue?vue&type=script&setup=true&lang=js"

import "./LimitTagList.vue?vue&type=style&index=0&id=56e72592&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56e72592"]])

export default __exports__